import { render, staticRenderFns } from "./ModalSmall.vue?vue&type=template&id=240ef0f0&"
import script from "./ModalSmall.vue?vue&type=script&lang=js&"
export * from "./ModalSmall.vue?vue&type=script&lang=js&"
import style0 from "./ModalSmall.vue?vue&type=style&index=0&id=240ef0f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports